export type TableColumnType = 'String' | 'Integer' | 'Double' | 'Boolean' | 'Dropdown';

export interface TableColumnConfig {
  name: string;
  type: TableColumnType;
  options?: string[];
}

export interface TableRowConfig {
  name: string;
}

export interface TableConfig {
  columns: TableColumnConfig[];
  rows: TableRowConfig[];
  allowAddRows: boolean;
}

export interface TableRowValue {
  rowName: string;
  cells: Record<string, string>;
}

export function getTableConfig(composition: unknown): TableConfig | null {
  return (composition as any)?.tableConfig ?? null;
}

export function parseTableValue(raw: string | null | undefined): TableRowValue[] {
  if (!raw) return [];
  try {
    return JSON.parse(raw) as TableRowValue[];
  } catch {
    return [];
  }
}

export function buildInitialRows(config: TableConfig): TableRowValue[] {
  return config.rows.map(row => ({
    rowName: row.name,
    cells: Object.fromEntries(config.columns.map(col => [col.name, ''])),
  }));
}
